import React from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import ThemeWrapper from './containers/layout/ThemeWrapper';
import store from './redux/store';
import AppRouter from './router';
import NotiHandler from './errors/NotiHandler';
import { initialState } from './redux/reducer';
import {
  getCachedBranding,
  applyDocumentBranding,
  PLATFORM_BRANDING,
} from './utils/branding';

const notistackRef = React.createRef();

const App = () => {
  // On bootstrap, theme the UI from the cached branding regardless of session:
  // a returning user (even after logout) keeps seeing their tenant's branding
  // on the login screen; a fresh browser (empty cache) falls back to the
  // platform default. After login, GET /tenants refreshes + re-caches it.
  const branding = getCachedBranding() || PLATFORM_BRANDING;

  applyDocumentBranding(branding);

  const initState = {
    ...initialState,
    theme: {
      ...initialState.theme,
      ...branding,
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store(initState)}>
        <CssBaseline />
        <ThemeWrapper>
          <SnackbarProvider
            preventDuplicate
            maxSnack={3}
            ref={notistackRef}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <NotiHandler>
              <AppRouter />
            </NotiHandler>
          </SnackbarProvider>
        </ThemeWrapper>
      </Provider>
    </LocalizationProvider>
  );
};

export default App;
